import script from "./ConnectedServicesSectionDW5V2.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedServicesSectionDW5V2.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedServicesSectionDW5V2.vue?vue&type=style&index=0&id=3afcebf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3afcebf0"]])

export default __exports__